<template>
  <v-dialog v-model="dialog" width="960">
    <template v-slot:activator="{ on: dialog }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on: tooltip }">
          <v-btn large icon v-on="{ ...tooltip, ...dialog }">
            <v-icon>mdi-filter</v-icon>
          </v-btn>
        </template>
        <span>Group Filter(s)</span>
      </v-tooltip>
    </template>

    <v-card raised class="pb-2">
      <v-toolbar flat dark color="primary">
        <v-toolbar-title>Manage Filters</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false"
          ><v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-3 pb-2">
        <div>
          <v-form ref="form" v-model="valid" lazy-validation="">
            <v-row>
              <v-col>
                <v-text-field
                  label="Group Url"
                  v-model="filters.group"
                  outlined
                  dense
                  clearable
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  label="Title Tag"
                  v-model="filters.title_tag_group"
                  outlined
                  dense
                  clearable
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  label="Anchor Text"
                  v-model="filters.anchor_text_group"
                  outlined
                  dense
                  clearable
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-select
                  :items="statusItems"
                  item-text="text"
                  item-value="value"
                  v-model="filters.type"
                  outlined
                  dense
                  clearable
                  hide-details="auto"
                  label="Group Type"
                ></v-select>
              </v-col>
              <v-col>
                <v-text-field
                  label="Group Extension"
                  v-model="filters.extension"
                  outlined
                  dense
                  clearable
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  label="Updated By"
                  v-model="filters.updated_by"
                  outlined
                  dense
                  clearable
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  label="Assignee"
                  v-model="filters.assignee"
                  outlined
                  dense
                  clearable
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-select
                  label="Date Type"
                  outlined
                  dense
                  v-model="filters.date_field"
                  :items="date_field_options"
                  hide-details="auto"
                ></v-select>
              </v-col>
              <v-col>
                <v-menu
                  ref="startMenu"
                  v-model="startMenu"
                  :close-on-content-click="false"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="startDateFormatted"
                      label="Start Date"
                      placeholder="MM/DD/YYYY"
                      persistent-hint
                      clearable
                      outlined
                      dense
                      hide-details="auto"
                      v-on:keyup.enter="
                        filters.start_date = parseDate(startDateFormatted)
                      "
                      @blur="filters.start_date = parseDate(startDateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filters.start_date"
                    no-title
                    color="secondary"
                    @input="startMenu = false"
                    :max="
                      filters.end_date
                        ? parseDate(filters.end_date)
                        : parseDate(today)
                    "
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col>
                <v-menu
                  ref="endMenu"
                  v-model="endMenu"
                  :close-on-content-click="false"
                  offset-y
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="endDateFormatted"
                      label="End Date"
                      placeholder="MM/DD/YYYY"
                      persistent-hint
                      clearable
                      outlined
                      dense
                      hide-details="auto"
                      v-on:keyup.enter="
                        filters.end_date = parseDate(endDateFormatted)
                      "
                      @blur="filters.end_date = parseDate(endDateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="filters.end_date"
                    no-title
                    color="secondary"
                    @input="endMenu = false"
                    :min="filters.start_date"
                    :max="parseDate(today)"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-card-text>

      <v-card-actions class="px-6 pt-0 pb-4">
        <v-spacer></v-spacer>
        <v-btn text @click="resetFilters">Reset Filters</v-btn>
        <v-btn color="success" dark @click="applyFilters">Apply Filters</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  props: ["headers"],
  data() {
    return {
      dialog: false,
      valid: true,
      statusItems: [
        { text: "Domain", value: "domain" },
        { text: "Subdomain", value: "subdomain" },
      ],
      filters: null,
      endMenu: false,
      startMenu: false,
      startDateFormatted: null,
      endDateFormatted: null,
      date_field_options: [
        { value: "created_at", text: "Created" },
        { value: "updated_at", text: "Updated" },
      ],
      dateFormat: {
        format: "MM/DD/YYYY",
        parse: "YYYY-MM-DD",
        display: "MMM D, YYYY",
      },
    };
  },
  methods: {
    replaceUndefinedOrNull(key, value) {
      if (value === null || value === undefined) {
        return undefined;
      }

      return value;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(date).format(this.dateFormat.parse);
    },
    formatDate(date) {
      if (!date) return null;
      return moment(date).format(this.dateFormat.format);
    },
    applyFilters() {
      this.$store.dispatch("groupFilters/setFilters", this.filters);

      this.dialog = false;
      this.$emit("filtersUpdated");
    },
    resetFilters() {
      this.$store.dispatch("groupFilters/clearFilters");
      this.filters = this.getDefaultFilters();
      this.$emit("filtersUpdated");
    },
    /*
id?: number,
  group?: string,
  type?: GroupType,
  extension?: string,
  status?: DomainStatus,
  project_id?: number,
  assignee_id?: number,
  created_at?: Date,
  updated_at?: Date,
  updated_by?: string,
*/
    getDefaultFilters() {
      return {
        group: null,
        extension: null,
        type: null,
        updated_by: null,
        start_date: null,
        end_date: null,
        date_field: "created_at",
      };
    },
    getHeader(id) {
      let header = this.headers.find((header) => header.value === id);
      return header ? header : false;
    },
    getHeaderType(id) {
      let header = this.getHeader(id);
      return header ? header.filterType : false;
    },
    getHeaderText(id) {
      let header = this.getHeader(id);
      return header ? header.text : false;
    },
  },
  watch: {
    "filters.start_date"(val) {
      this.startDateFormatted = this.formatDate(val);
    },
    "filters.end_date"(val) {
      this.endDateFormatted = this.formatDate(val);
    },
  },
  computed: {
    today() {
      return moment();
    },
    ...mapGetters({
      activeFilters: "groupFilters/filters",
    }),
  },
  created() {
    if (Object.keys(this.activeFilters).length !== 0) {
      this.filters = this.activeFilters;
    } else {
      this.filters = this.getDefaultFilters();
    }
    this.filterableHeaders = this.headers.filter((header) => header.filterType);
  },
};
</script>

<style></style>
